import React, { Dispatch, SetStateAction } from "react";
import { sortBy } from "lodash";
import { arrayHasExactlyOneItem } from "common/utils/arrays";
import { DATUM_DISPLAY } from "common/utils/datums";
import { DatumToggleOrder } from "common/utils/datums";
import { GetAccountQuery } from "../../../generated/graphql";
import { Button } from "../../Common/Buttons/Button";
import { DatumButton } from "./__styles__/BuildingAttrInfo";

type Datum = NonNullable<
  NonNullable<NonNullable<GetAccountQuery>["account"]>["datums"]
>[number];

export const DatumToggle = ({
  selectedDatum,
  setSelectedDatum,
  datumOptions,
}: {
  selectedDatum: Maybe<Datum>;
  setSelectedDatum: Dispatch<SetStateAction<Maybe<Datum>>>;
  datumOptions: Array<Datum>;
}) => {
  if (!selectedDatum) {
    return null;
  }

  if (arrayHasExactlyOneItem(datumOptions)) {
    return (
      <Button
        size="small"
        variant="outline"
        title={DATUM_DISPLAY[datumOptions[0]].short}
      />
    );
  }

  const sortedDatumOptions = sortBy(
    datumOptions,
    datum => DatumToggleOrder[datum],
  );

  return (
    <>
      {sortedDatumOptions.map(datum => (
        <DatumButton
          key={datum}
          size="small"
          onPress={() => setSelectedDatum(datum)}
          variant={selectedDatum === datum ? "primary" : "outline"}
          title={DATUM_DISPLAY[datum].short}
        />
      ))}
    </>
  );
};
